import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/baseParam/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/baseParam/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/baseParam/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/baseParam/delete/${id}`)
}

// 获取
export function baseParamList (params) {
  return request.get(`/business/baseParam/baseParamList`, {params})
}
